import React from "react";
import { FloatingQRCodeContainer } from "./styles";
import { Dialog, mediaQuery, Text } from "@hubble/web";
import NextImage from "components/parts/NextImage";
import { useTranslations } from "i18n";
import { FILES } from "i18n/constants";
import { useMedia } from "react-use";

const FloatingQRCode = () => {
  const t = useTranslations(FILES.COMMON);
  const isDesktop = useMedia(mediaQuery.tabletSmUp, false);

  if (!isDesktop) {
    return null;
  }

  return (
    <Dialog>
      <Dialog.Trigger>
        <FloatingQRCodeContainer>
          <Text.Body size="sm" pt={1} pb={1}>
            {t("appQRPopup.appQRPopupButtonText")}
          </Text.Body>
          <NextImage
            src="https://cdn.builder.io/api/v1/image/assets/1b77ce3a269a43e985e77f3d65f715ba/8bfd6080da0d44c59c726925fc8868f6"
            height={57}
            width={57}
            alt="QR code"
          />
        </FloatingQRCodeContainer>
      </Dialog.Trigger>
      <Dialog.Container>
        <Dialog.Header>
          <Dialog.Title>{t("appQRPopup.appQRPopupTitle")}</Dialog.Title>
          <Dialog.Description>
            {t("appQRPopup.appQRPopupDescription")}
          </Dialog.Description>
        </Dialog.Header>
        <Dialog.Content>
          <NextImage
            style={{
              display: "block",
              margin: "1rem auto 0.5rem"
            }}
            height={128}
            width={128}
            alt="QR code"
            priority
            src="https://cdn.builder.io/api/v1/image/assets/1b77ce3a269a43e985e77f3d65f715ba/ddd1a86aaa5b4415a891b32ff088ff45"
          />
        </Dialog.Content>
      </Dialog.Container>
    </Dialog>
  );
};

export default FloatingQRCode;
